
import { addLocale } from 'primereact/api';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from "primereact/inputtextarea";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import '../Helper/links';
import { _endPoints } from "../Helper/links";
import API from "../Helper/server/API";
import '../public/themes/saga-blue/theme.css';
import { Message } from 'primereact/message';
import { Knob } from 'primereact/knob';
import { OverlayPanel } from 'primereact/overlaypanel';

function SystemSetUp() {
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const toast = useRef(null);
    const opUpdateRefs = useRef(null);
    //____________________________________________________________
    const [Invoice, setInvoice] = useState(false);
    const [ShowCofigReport, setShowCofigReport] = useState(false);
    const [reosrt_name, set_reosrt_name] = useState('');
    const renderHowShow = () => {
        return (
            <div className="col-md-12">
                <center>
                    <hr></hr>
                    <h6>بيانات الحجز</h6>
                    <hr></hr>
                </center>
                <div className="row">
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>رقم الحجز</label>

                        </center>
                    </div>
                </div>
            </div>
        );
    };

    const print = () => {
        setInvoice(true);
    };
    //_______________________________________________________________________________________
    //                      Get Reservationes
    const [loding_get_resort, set_loding_get_resort] = useState(true);
    const [resort, set_reosrt] = useState({})
    const GetMyReosrt = async () => {
        set_loding_get_resort(true)
        const response = await API.get(_endPoints.resorts.my)
        if (response?.success === 1) {
            set_reosrt({
                ...response.data,
                dates: response?.data?.from_date_check_in && response?.data?.to_date_check_in ? [new Date(response?.data?.from_date_check_in), new Date(response?.data?.to_date_check_in)] : [new Date(), new Date(new Date().getFullYear() + 1, 11, 31)]
            });
        }
        else {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 3000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loding_get_resort(false)
    }
    const [loding_update_resort, set_loding_update_resort] = useState(false);
    const UpdateReosrt = async () => {
        set_loding_update_resort(true);
        var data = {
            minimum_paid: resort.minimum_paid,
            limit_booking_month: resort.limit_booking_month,
            change_time_delete: resort?.change_time_delete,
            hours_delete: resort?.hours_delete,
            max_days_booking: resort.max_days_booking,
            available_day: resort.available_day,
            identity_document: resort.identity_document,
            booking_mobile_app: resort.booking_mobile_app,
            dates: resort.dates,
        }
        const response = await API.post(_endPoints.resorts.udpate, data)
        if (response?.success) {
            toast.current.show({
                style: {
                    fontSize: "1.2rem",
                    fontFamily: "Cairo"
                },
                life: 3000,
                severity: 'success', summary: ' نجــاح ', detail: response?.msg
            });
            set_reosrt({ ...response.data, dates: [new Date(response?.data?.from_date_check_in), new Date(response?.data?.to_date_check_in)] });
            setShowCofigReport(false);
        }
        else if (response?.success === 0) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 3000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loding_update_resort(false);
    }

    useEffect(() => {
        GetMyReosrt();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="page-wrapper" dir="rtl" >
            <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important" }} remove />
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div className="page-heading">
                    <h1 className="page-title">  إعـــداد النظــام </h1>
                </div>
                <div className="card">
                    <div class="clf" key={1}>
                        <ul class="nav nav-tabs tabs-line nav-fill">
                            <li class="nav-item">
                                <a class={"nav-link active"} href={`#tab-1`} data-toggle="tab">
                                    <h6>بيــانات المنتجــع</h6>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class={"nav-link"} href={`#tab-2`} data-toggle="tab">
                                    <h6>شــروط وأحكــام الحجـــز</h6>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class={"nav-link"} href={`#tab-2`} data-toggle="tab" >
                                    <h6>مكــاتب الحجــز</h6>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content mt-5">
                            <div class={"tab-pane show active"} id={`tab-1`}>
                                {
                                    loding_get_resort ?
                                        <div className="row">
                                            <div className="col-md-12 ">
                                                <center>
                                                    <Skeleton width="90%" height='40rem'  ></Skeleton>
                                                </center>
                                            </div>
                                        </div>
                                        :

                                        <div className='col-md-12'>
                                            <div className="row">
                                                <div className="col-md-3 mb-4">
                                                    <label id="lreosrt_name"> شعــار المنتجــع</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <br></br>
                                                    <Avatar image={_endPoints.resorts.images + resort.logo_path} style={{ width: "100%", height: "100%" }} className="mr-2" size="xlarge" shape="circle" />
                                                </div>
                                                <div className="col-md-1 mb-4">
                                                    <label id="lreosrt_name"> الرمــز</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={`${resort.short_name}`}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>
                                                <div className="col-md-2 mb-4">
                                                    <label id="lreosrt_name"> أســم المنتجــع</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={resort.name_ar}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>
                                                <div className="col-md-2 mb-4">
                                                    <label id="lreosrt_name" className="col-md-12">  أســم المنتجــع بالإنجليــزي </label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={resort.name_en}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>

                                                <div className="col-md-2 mb-4">
                                                    <label id="lreosrt_name">1 رقــم الهــاتف</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={`0${resort.phone_1}`}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>

                                                <div className="col-md-2 mb-4">
                                                    <label id="lreosrt_name">2 رقــم الهــاتف</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={`0${resort.phone_2}`}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>

                                                <div className="col-md-3 mb-4">

                                                </div>

                                                <div className="col-md-2 mb-4">
                                                    <label id="lreosrt_name"> البــريد الإلكتــروني</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={`0${resort.email}`}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>

                                                <div className="col-md-2 mb-4">
                                                    <label id="lreosrt_name">العنــوان</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={`${resort.city} - ${resort.address}`}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>

                                                <div className="col-md-2 mb-4">
                                                    <label id="lreosrt_name">أحــدثيــات العنــوان</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={`${resort.longitude}-${resort.latitude}`}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>
                                                <div className="col-md-2 mb-4">
                                                    <label id="lreosrt_name">المــوقع الإلكــتروني</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputText value={`${resort.website}`}
                                                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black" }} inputStyle={{ fontFamily: "Cairo", fontWeight: "bold" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }} disabled />
                                                </div>

                                                <div className="col-md-5 mb-4">
                                                    <label id="lreosrt_name">تفـاصيـل</label>
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <InputTextarea variant="filled" id="username" value={resort.details} rows={10} cols={100} style={{ fontFamily: "Cairo", fontWeight: "bold", color: "black", width: "100%" }} disabled />
                                                </div>

                                                <div className="col-md-5 mb-4">
                                                    < label id="msg_reosrt_name" style={{ paddingRight: "50px" }}></label>
                                                    <Button
                                                        type="button" severity="secondary"
                                                        icon="fa fa-cog ml-2" label="إدارة الحجــز"
                                                        outlined
                                                        onClick={(e) => setShowCofigReport(true)}
                                                        style={{ marginTop: "25px" }}
                                                    />
                                                </div>



                                            </div>
                                        </div>
                                }
                            </div>
                            <div class={"tab-pane"} id={`tab-2`}>
                                <div className='col-md-12'>

                                </div>
                            </div>
                        </div>
                    </div>

                    <br></br>

                </div>
                <Dialog dir="rtl" header="تعديــل إدارة الحجــز" visible={ShowCofigReport} maximizable style={{ width: '60vw', fontFamily: "Cairo" }} onHide={() => setShowCofigReport(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                    <hr></hr>
                    <div className='col-md-12'>
                        <div className="row mt-4">
                            <div className="col-md-4 mb-4">
                                <center>
                                    <label id="lreosrt_name" style={{ fontWeight: "bold" }} className="col-md-12">التــوريخ المتــاحة للحجــز</label>

                                    <Calendar
                                        value={resort?.dates} minDate={new Date()}
                                        selectionMode="range"
                                        readOnlyInput
                                        hideOnRangeSelection
                                        dateFormat="yy-mm-dd"
                                        panelStyle={{ width: "auto" }}
                                        inputStyle={{ fontWeight: "bold", textAlign: "center" }}
                                        locale="ar"
                                        numberOfMonths={1}
                                        onChange={(e) => {
                                            set_reosrt({ ...resort, dates: e.value })
                                        }}
                                    />
                                </center>
                            </div>
                            <div className="col-md-3 mb-4">
                                <label id="lreosrt_name" style={{ fontWeight: "bold" }} className="col-md-12 pr-0">عدد الحجوزات للعميل في الشهر</label>
                                <InputNumber value={resort?.limit_booking_month} showButtons buttonLayout="horizontal" style={{ width: '4rem', textAlign: "center" }} inputStyle={{ fontSize: "1.3rem", fontWeight: "bold", textAlign: "center" }}
                                    decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                                    onValueChange={(e) => {
                                        set_reosrt({ ...resort, limit_booking_month: e.value })
                                    }}
                                />
                            </div>
                            <div className="col-md-3 mb-4">
                                <label id="lreosrt_name" style={{ fontWeight: "bold" }} className="col-md-12 pr-0"> الحد الأقصي لأيام الحجز</label>
                                <br></br>
                                <InputNumber value={resort?.max_days_booking} showButtons buttonLayout="horizontal" style={{ width: '4rem' }} inputStyle={{ fontSize: "1.3rem", fontWeight: "bold", textAlign: "center" }}
                                    decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                                    onValueChange={(e) => {
                                        set_reosrt({ ...resort, max_days_booking: e.value })
                                    }}
                                />
                            </div>
                            <div className="col-md-2 mb-4">
                                <label id="lreosrt_name" style={{ fontWeight: "bold" }} className="col-md-12 pr-0"> الحد الأدنى للدفع</label>
                                <br></br>
                                <InputNumber value={resort?.minimum_paid} showButtons buttonLayout="horizontal" style={{ width: '4rem' }} inputStyle={{ fontSize: "1.3rem", fontWeight: "bold", textAlign: "center" }}
                                    decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                                    onValueChange={(e) => {
                                        set_reosrt({ ...resort, minimum_paid: e.value })
                                    }} prefix="%"
                                />
                            </div>
                        </div>
                        <hr></hr>
                        <div className="row mt-4">
                            <div className="col-md-3 mb-4">
                                <label id="lreosrt_name" style={{ fontWeight: "bold" }} className="col-md-12">عدم إتاحة يوم فارغ</label>
                                <Button icon={resort?.available_day ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={resort?.available_day ? "فعـــال" : "متــوقف"} outlined severity={resort?.available_day ? "success" : "danger"} size="large" className='mr-1'
                                    onClick={(e) => {
                                        if (resort?.available_day)
                                            set_reosrt({ ...resort, available_day: 0 });
                                        else
                                            set_reosrt({ ...resort, available_day: 0 });
                                    }} />
                            </div>
                            <div className="col-md-3 mb-4">
                                <label id="lchange_time_delete" style={{ fontWeight: "bold" }} className="col-md-12"> تعديل وقت إلـغـاء الحجــز</label>
                                <Button icon={resort?.change_time_delete ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={resort?.change_time_delete ? "فعـــال" : "متــوقف"} outlined severity={resort?.change_time_delete ? "success" : "danger"} size="large" className='mr-1'
                                    onClick={(e) => {
                                        if (resort?.change_time_delete)
                                            set_reosrt({ ...resort, change_time_delete: 0 });
                                        else
                                            set_reosrt({ ...resort, change_time_delete: 1 });
                                    }} />
                            </div>

                            <div className="col-md-3 mb-4">
                                <label id="lchange_time_delete" style={{ fontWeight: "bold" }} className="col-md-12"> تعديل وقت إلـغـاء الحجــز</label>
                                <Button
                                    label={
                                        <>
                                            {resort?.hours_delete} ساعات
                                        </>
                                    }
                                    outlined
                                    style={{ fontSize: "1.1rem", fontWeight: "bold" }}
                                    onClick={(e) => opUpdateRefs?.current?.toggle(e)}
                                />
                                <OverlayPanel
                                    ref={opUpdateRefs}
                                    dismissable
                                    className="custom-overlaypanel"
                                >
                                    <>
                                        <Knob value={resort?.hours_delete > 0 ? resort?.hours_delete : 0} size={120} min={1} max={120} dir='ltr' valueTemplate={`${resort?.hours_delete >= 0 ? resort?.hours_delete : 0} ســ `}
                                            onChange={(e) => {
                                                if (e.value >= 1 && e.value <= 120)
                                                    set_reosrt({ ...resort, hours_delete: e.value });
                                            }}
                                        />
                                        <center>ســاعات</center>
                                        <Button icon="pi pi-plus" onClick={(e) => {
                                            if (Number.isInteger(resort?.hours_delete) && resort?.hours_delete > 0 && resort?.hours_delete < 120)
                                                set_reosrt({ ...resort, hours_delete: resort?.hours_delete + 1 });
                                            else
                                                set_reosrt({ ...resort, hours_delete: 1 });
                                        }} className='mr-2' text />
                                        <Button icon="pi pi-minus" onClick={(e) => {
                                            if (Number.isInteger(resort?.hours_delete) && resort?.hours_delete > 1)
                                                set_reosrt({ ...resort, hours_delete: resort?.hours_delete - 1 });
                                            else
                                                set_reosrt({ ...resort, hours_delete: 1 });

                                        }} disabled={resort?.hours_delete === 0} className='mr-4' text />
                                    </>
                                </OverlayPanel>
                            </div>
                        </div>
                        <hr></hr>
                        <center>
                            <Message severity="warn" text={<h5 className='mr-2 ml-4 mt-2 font-bold '>إعداد خاصة بالتطبيق فقـط</h5>} className='p-2 ' clas size="large" />
                        </center>
                        <hr></hr>
                        <div className="row mt-4">
                            <div className="col-md-3 mb-4">
                                <label id="lreosrt_name" style={{ fontWeight: "bold" }} className="col-md-12">  تحقق الهوية عند الحجز الحجــز</label>
                                <Button icon={resort?.identity_document ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={resort?.identity_document ? "فعـــال" : "متــوقف"} outlined severity={resort?.identity_document ? "success" : "danger"} size="large" className='mr-1'
                                    onClick={(e) => {
                                        if (resort?.identity_document)
                                            set_reosrt({ ...resort, identity_document: 0 });
                                        else
                                            set_reosrt({ ...resort, identity_document: 1 });
                                    }} />
                            </div>

                            <div className="col-md-3 mb-4">
                                <label id="lreosrt_name" style={{ fontWeight: "bold" }} className="col-md-12">الحجــز من خـلال التطبيـق</label>
                                <Button icon={resort?.booking_mobile_app ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={resort?.booking_mobile_app ? "فعـــال" : "متــوقف"} outlined severity={resort?.booking_mobile_app ? "success" : "danger"} size="large" className='mr-1'
                                    onClick={(e) => {
                                        if (resort?.booking_mobile_app)
                                            set_reosrt({ ...resort, booking_mobile_app: 0 });
                                        else
                                            set_reosrt({ ...resort, booking_mobile_app: 1 });
                                    }} />
                            </div>
                        </div>
                        <hr></hr>
                        <div className="row">
                            <div className="col-md-12 mb-4">
                                <center>
                                    <Button
                                        type="button" severity="danger" className="ml-2"
                                        icon="fa fa-times ml-2" label=" إلـغـاء "
                                        outlined
                                        onClick={(e) => setShowCofigReport(false)}
                                        style={{ marginTop: "25px" }}
                                    />
                                    <Button
                                        type="button" severity="success"
                                        icon="fa fa-check ml-2" label=" حفــظ "
                                        outlined
                                        onClick={UpdateReosrt} loading={loding_update_resort}
                                        style={{ marginTop: "25px" }}

                                    />
                                </center>
                            </div>
                        </div>
                    </div>
                </Dialog>
                {
                    Invoice ?
                        (
                            <Dialog dir="rtl" header="فاتورة الحجوزات" visible={Invoice} maximizable style={{ width: '90vw', fontFamily: "Cairo" }} onHide={() => setInvoice(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                                test
                            </Dialog>
                        )
                        :
                        (null)
                }
            </div>
        </div>
    )
}

export default SystemSetUp


